export default "__VITE_ASSET__BFlB0paL__"